const storeTypes = {
  SET_BASIC_INFO: "BASIC INFO",
  PETS_INFO: "PETS INFO",
  PARTNER_INFO: "PARTNER INFO",
  PARTNER_GENDER: "PARTNER GENDER",
  PARTNER_PLAN: "PARTNER PLAN",
};
export default storeTypes;
